import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import usePlatformConfig from '../../common/react/usePlatformConfig';
import { customiseActions } from '../store/reducers/customiseReducer';
import customiseSelectors from '../store/selectors/customiseSelectors';
import useCustomerStorage from '../../common/hooks/useCustomerStorage';

interface IUsePersistedCurrencyPreferenceReturn {
  isSecondaryCurrencyDisplay: boolean;
  setIsSecondaryCurrencyDisplay: (isSecondaryCurrencyDisplay: boolean) => void;
}

export const usePersistedCurrencyPreference: () => IUsePersistedCurrencyPreferenceReturn = () => {
  const dispatch = useDispatch();
  const isSecondaryCurrencyDisplay = useSelector(customiseSelectors.getIsSecondaryCurrencyDisplay);
  const {
    platformConfig: { priceDisplay },
  } = usePlatformConfig();
  const { primary, secondary } = priceDisplay;
  const { customerStorage } = useCustomerStorage();
  const storageInfo = customerStorage.getCustomerData();
  const storageCurrency = storageInfo?.selectedCurrency;

  useEffect(() => {
    // Check on load or on FC changes for existing currency preference.
    dispatch(customiseActions.setIsSecondaryCurrencyDisplay(storageCurrency === secondary?.currency));
  }, [storageCurrency]);

  const setIsSecondaryCurrencyDisplay = useCallback(() => {
    dispatch(customiseActions.setIsSecondaryCurrencyDisplay(!isSecondaryCurrencyDisplay));
    storageInfo.selectedCurrency = isSecondaryCurrencyDisplay ? primary?.currency : secondary?.currency;

    customerStorage.setCustomerData(storageInfo);
  }, [isSecondaryCurrencyDisplay]);

  return { isSecondaryCurrencyDisplay, setIsSecondaryCurrencyDisplay };
};
